const Config = require('../../../config');

const {
    env: { IS_DE_LANG_ENV, IS_CS_LANG_ENV, IS_EN_LANG_ENV },
} = Config;

const csRoutes = {
    [Config.routes['/']]: '/',
    [Config.routes['/uikit']]: '/uikit',
    [Config.routes['/app-development']]: '/vyvoj-aplikaci',
    [Config.routes['/about-us']]: '/o-nas',
    [Config.routes.prArticle]: '/o-nas/:prArticle',
    [Config.routes['/contact']]: '/kontakt',
    [Config.routes['/contact/prague']]: '/praha',
    [Config.routes['/contact/berlin']]: '/berlin',
    [Config.routes['/contact/thank-you-inquiry']]: '/kontakt/thank-you',
    [Config.routes['/contact/thank-you-hr']]: '/kontakt/thank-you-hr',
    [Config.routes['/app-workshop']]: '/workshop-aplikace',
    [Config.routes['/career']]: '/kariera',
    [Config.routes['/designPage']]: '/design',
    [Config.routes['/references']]: '/reference',
    [Config.routes['/references/archive']]: '/reference/archiv',
    [Config.routes['/christmas2020']]: '/vanoce2020',
    [Config.routes.notFound]: '/404.html',
    [Config.routes['/cookiesPage']]: '/cookies',
    // REFERENCES
    [Config.routes.references.cosmo]: '/dorucovani-do-kufru-skoda-auto-digilab',
    [Config.routes.references.zonky]: '/zonky',
    [Config.routes.references.bundestag]: '/bundestag-app',
    [Config.routes.references.samsung]: '/samsung',
    [Config.routes.references.kosik]: '/kosik',
    [Config.routes.references.kolofix]: '/kolofix',
    [Config.routes.references.hi5]: '/hi5',
    [Config.routes.references.ventusky]: '/ventusky',
    [Config.routes.references.babysitting]: '/babysitting-today',
    [Config.routes.references.ethereum]: '/ethereum-ios-dev-kit',
    [Config.routes.references.skodamoped]: '/skoda-moped',
    [Config.routes.references.pzr]: '/prace-za-rohem',
    [Config.routes.references.obbod]: '/obbod-android-tv',
    [Config.routes.references.tmobile]: '/t-mobile-vanocni-zavod',
    [Config.routes.references.bazos]: '/bazos',
    [Config.routes.references.equa]: '/equa-bank',
    [Config.routes.references.oto]: '/oto-shape-of-sound',
    [Config.routes.references.rekola]: '/rekola',
    [Config.routes.references.nevdama]: '/nev-dama',
    [Config.routes.references.virgla]: '/virgla-cms',
    [Config.routes.references.grenke]: '/grenke',
    [Config.routes.references.tamtam]: '/tamtam',
    [Config.routes.references.tapito]: '/tapito',
    [Config.routes.references.simplifa]: '/simplifa',
    [Config.routes.references.fakturoid]: '/fakturoid',
    [Config.routes.references.carolina]: '/carolina',
    [Config.routes.references.deliveryhero]: '/delivery-hero',
    [Config.routes.references.flashsport]: '/reference/flashsport',
    [Config.routes.references.flashnews]: '/reference/flashnews',
    [Config.routes.references.wwf]: '/reference/wwf',
    [Config.routes.references.citymove]: '/reference/citymove',
    [Config.routes.references.cme]: '/reference/cme',
    [Config.routes.references.weshare]: '/reference/weshare',
    [Config.routes.references.moneyStep]: '/reference/money-step',
    [Config.routes.references.hopi]: '/reference/hopi',
    [Config.routes.references.criticalStates]: '/reference/krizove-stavy',
    [Config.routes.references.moneyStep]: '/reference/money-step',
    [Config.routes.references.dpnk]: '/reference/do-prace-na-kole',
    [Config.routes.references.ivysilani]: '/reference/ivysilani',
    [Config.routes.references.boxNow]: '/reference/boxnow',
    [Config.routes.references.wwfGhostdiver]: '/reference/wwf-ghostdiver',
    [Config.routes.references.kviff]: '/reference/kviff',
    [Config.routes.references.vivents]: '/reference/vivents',
    [Config.routes.references.mladyZdravotnik]: '/reference/mlady-zdravotnik',
    [Config.routes.references.glitter]: '/reference/glitter',
    [Config.routes.references.co2in]: '/reference/co2in',
    [Config.routes.references.shipmonk]: '/reference/shipmonk',
    [Config.routes.references.edoklady]: '/reference/edoklady',
    [Config.routes.references.showcase]: '/reference/showcase',
    [Config.routes.references.travelFree]: '/reference/travel-free',
    [Config.routes.references.prochmel]: '/reference/prochmel',
    [Config.routes.references.jtbanka]: '/reference/jtbanka',
    [Config.routes.references.omg]: '/reference/omg-konsent',
    [Config.routes.references.oneplay]: '/reference/oneplay',

    // POSITIONS
    [Config.routes.positions.androidDev]: '/kariera/android-developer',
    [Config.routes.positions.backendDev]: '/kariera/backend-developer',
    [Config.routes.positions.frontEndDev]: '/kariera/frontend-developer',
    [Config.routes.positions.iOSDev]: '/kariera/ios-developer',
    [Config.routes.positions.projectManager]: '/kariera/project-manager',
    [Config.routes.positions.accountManager]: '/kariera/account-manager',
    [Config.routes.positions.appTester]: '/kariera/app-tester',
    [Config.routes.positions.designer]: '/kariera/designer',
    [Config.routes.positions.intern]: '/kariera/trainee',
    [Config.routes.positions.careerNotFound]: '/kariera/kontakt',

    // BLOG
    [Config.routes['/blog']]: '/blog',
    [Config.routes.blog.page]: '/blog/page/:page',
    [Config.routes.blog.post]: '/blog/:post',
    [Config.routes.blog.postsAuthor]: '/blog/author/:author/:page?',
    [Config.routes.blog.postsCategory]: '/blog/category/:category/:page?',
    [Config.routes.blog.postsTag]: '/blog/tag/:tag/:page?',
    [Config.routes.blog.glossaryItem]: '/blog/glossary/:glossaryItem',
};

const enRoutes = {
    [Config.routes['/']]: '/',
    [Config.routes['/uikit']]: '/the-uikit',
    [Config.routes['/app-development']]: '/app-development',
    [Config.routes['/about-us']]: '/about-us',
    [Config.routes.prArticle]: '/about-us/:prArticle',
    [Config.routes['/contact']]: '/contact',
    [Config.routes['/contact/prague']]: '/prague',
    [Config.routes['/contact/berlin']]: '/berlin',
    [Config.routes['/contact/thank-you-inquiry']]: '/contact/thank-you',
    [Config.routes['/contact/thank-you-hr']]: '/contact/thank-you-hr',
    [Config.routes['/app-workshop']]: '/app-workshop',
    [Config.routes['/career']]: '/career',
    [Config.routes['/designPage']]: '/design',
    [Config.routes['/references']]: '/references',
    [Config.routes['/references/archive']]: '/reference/archive',
    [Config.routes['/christmas2020']]: '/christmas2020',
    [Config.routes.notFound]: '/404.html',
    [Config.routes['/cookiesPage']]: '/cookies',

    // REFERENCES
    [Config.routes.references.cosmo]: '/trunk-delivery-skoda-auto-digilab',
    [Config.routes.references.zonky]: '/zonky',
    [Config.routes.references.bundestag]: '/bundestag-app',
    [Config.routes.references.samsung]: '/samsung',
    [Config.routes.references.kosik]: '/kosik',
    [Config.routes.references.kolofix]: '/kolofix',
    [Config.routes.references.hi5]: '/hi5',
    [Config.routes.references.ventusky]: '/ventusky',
    [Config.routes.references.babysitting]: '/babysitting-today',
    [Config.routes.references.ethereum]: '/ethereum-ios-dev-kit',
    [Config.routes.references.skodamoped]: '/skoda-moped',
    [Config.routes.references.pzr]: '/prace-za-rohem',
    [Config.routes.references.obbod]: '/obbod-android-tv',
    [Config.routes.references.tmobile]: '/t-mobile',
    [Config.routes.references.bazos]: '/bazos',
    [Config.routes.references.equa]: '/equa-bank',
    [Config.routes.references.oto]: '/oto-shape-of-sound',
    [Config.routes.references.rekola]: '/rekola',
    [Config.routes.references.nevdama]: '/nev-dama',
    [Config.routes.references.virgla]: '/virgla-cms',
    [Config.routes.references.grenke]: '/grenke',
    [Config.routes.references.tamtam]: '/tamtam',
    [Config.routes.references.tapito]: '/tapito',
    [Config.routes.references.simplifa]: '/simplifa',
    [Config.routes.references.fakturoid]: '/fakturoid',
    [Config.routes.references.carolina]: '/carolina',
    [Config.routes.references.deliveryhero]: '/delivery-hero',
    [Config.routes.references.wwf]: '/references/wwf',
    [Config.routes.references.flashsport]: '/references/flashsport',
    [Config.routes.references.flashnews]: '/references/flashnews',
    [Config.routes.references.citymove]: '/references/citymove',
    [Config.routes.references.cme]: '/references/cme',
    [Config.routes.references.weshare]: '/references/weshare',
    [Config.routes.references.moneyStep]: '/references/money-step',
    [Config.routes.references.hopi]: '/references/hopi',
    [Config.routes.references.criticalStates]: '/references/critical-states',
    [Config.routes.references.boxNow]: '/references/boxnow',
    [Config.routes.references.ivysilani]: '/references/ivysilani',
    [Config.routes.references.wwfGhostdiver]: '/references/wwf-ghostdiver',
    [Config.routes.references.kviff]: '/references/kviff',
    [Config.routes.references.vivents]: '/references/vivents',
    [Config.routes.references.glitter]: '/references/glitter',
    [Config.routes.references.co2in]: '/references/co2in',
    [Config.routes.references.shipmonk]: '/references/shipmonk',
    [Config.routes.references.edoklady]: '/references/edocuments',
    [Config.routes.references.showcase]: '/references/showcase',
    [Config.routes.references.travelFree]: '/references/travel-free',
    [Config.routes.references.prochmel]: '/references/prochmel',
    [Config.routes.references.jtbanka]: '/references/jtbanka',
    [Config.routes.references.omg]: '/references/omg-konsent',
    [Config.routes.references.oneplay]: '/reference/oneplay',

    // POSITIONS
    [Config.routes.positions.androidDev]: '/career/android-developer',
    [Config.routes.positions.backendDev]: '/career/backend-developer',
    [Config.routes.positions.frontEndDev]: '/career/frontend-developer',
    [Config.routes.positions.iOSDev]: '/career/ios-developer',
    [Config.routes.positions.projectManager]: '/career/project-manager',
    [Config.routes.positions.appTester]: '/career/app-tester',
    [Config.routes.positions.designer]: '/career/designer',
    [Config.routes.positions.intern]: '/career/trainee',
    [Config.routes.positions.careerNotFound]: '/career/kontakt',

    // BLOG
    [Config.routes['/blog']]: '/blog',
    [Config.routes.blog.page]: '/blog/page/:page',
    [Config.routes.blog.post]: '/blog/:post',
    [Config.routes.blog.postsAuthor]: '/blog/author/:author/:page?',
    [Config.routes.blog.postsCategory]: '/blog/category/:category/:page?',
    [Config.routes.blog.postsTag]: '/blog/tag/:tag/:page?',
    [Config.routes.blog.glossaryItem]: '/blog/glossary/:glossaryItem',
};

const deRoutes = {
    [Config.routes['/']]: '/',
    [Config.routes['/uikit']]: '/das-uikit',
    [Config.routes['/app-development']]: '/app-entwicklung',
    [Config.routes['/campaign']]: '/app-kostenlos',
    [Config.routes['/about-us']]: '/uber-ackee',
    [Config.routes.prArticle]: '/uber-ackee/:prArticle',
    [Config.routes['/contact']]: '/kontakt',
    [Config.routes['/contact/thank-you-inquiry']]: '/kontakt/thank-you',
    [Config.routes['/contact/thank-you-hr']]: '/kontakt/thank-you-hr',
    [Config.routes['/contact/prague']]: '/prag',
    [Config.routes['/contact/berlin']]: '/berlin',
    [Config.routes['/app-workshop']]: '/app-workshop',
    // [Config.routes['/career']]: '/karriere',
    [Config.routes['/designPage']]: '/design',
    [Config.routes['/references']]: '/referenzen',
    [Config.routes['/references/archive']]: '/referenzen/archiv',
    [Config.routes['/christmas2020']]: '/weihnacht2020',
    [Config.routes.notFound]: '/404.html',
    [Config.routes['/cookiesPage']]: '/cookies',

    // REFERENCES
    [Config.routes.references.cosmo]: '/kofferraum-lieferung-skoda-auto-digilab',
    [Config.routes.references.zonky]: '/zonky',
    [Config.routes.references.bundestag]: '/bundestag-app',
    [Config.routes.references.samsung]: '/samsung',
    // [Config.routes.references.kosik]: '',
    // [Config.routes.references.kolofix]: '',
    [Config.routes.references.hi5]: '/hi5',
    [Config.routes.references.ventusky]: '/ventusky',
    [Config.routes.references.babysitting]: '/babysitting-today',
    [Config.routes.references.ethereum]: '/ethereum-ios-dev-kit',
    [Config.routes.references.skodamoped]: '/skoda-moped',
    // [Config.routes.references.pzr]: '',
    // [Config.routes.references.obbod]: '',
    [Config.routes.references.tmobile]: '/t-mobile',
    // [Config.routes.references.bazos]: '',
    [Config.routes.references.equa]: '/equa-bank',
    [Config.routes.references.oto]: '/oto-shape-of-sound',
    // [Config.routes.references.rekola]: '',
    // [Config.routes.references.nevdama]: '',
    [Config.routes.references.virgla]: '/virgla-cms',
    [Config.routes.references.grenke]: '/grenke',
    [Config.routes.references.tamtam]: '/tamtam',
    [Config.routes.references.simplifa]: '/simplifa',
    [Config.routes.references.carolina]: '/carolina',
    [Config.routes.references.angelcam]: '/angelcam',
    [Config.routes.references.praguer]: '/praguer',
    [Config.routes.references.kitaportfolio]: '/kitaportfolio',
    [Config.routes.references.pocketFennec]: '/pocket-fennec',
    [Config.routes.references.cooljam]: '/cooljam-tour',
    [Config.routes.references.easyRedmine]: '/easy-redmine',
    [Config.routes.references.tapito]: '/tapito',
    [Config.routes.references.deliveryhero]: '/delivery-hero',
    [Config.routes.references.wwf]: '/referenzen/wwf',
    [Config.routes.references.flashsport]: '/referenzen/flashsport',
    [Config.routes.references.flashnews]: '/referenzen/flashnews',
    [Config.routes.references.citymove]: '/referenzen/citymove',
    [Config.routes.references.cme]: '/referenzen/cme',
    [Config.routes.references.weshare]: '/referenzen/weshare',
    [Config.routes.references.wwfGhostdiver]: '/referenzen/wwf-ghostdiver',
    [Config.routes.references.vivents]: '/referenzen/vivents',
    [Config.routes.references.co2in]: '/referenzen/co2in',
    [Config.routes.references.shipmonk]: '/referenzen/shipmonk',

    // BLOG
    [Config.routes['/blog']]: '/blog',
    [Config.routes.blog.page]: '/blog/page/:page',
    [Config.routes.blog.post]: '/blog/:post',
    [Config.routes.blog.postsAuthor]: '/blog/author/:author/:page?',
    [Config.routes.blog.postsCategory]: '/blog/category/:category/:page?',
    [Config.routes.blog.postsTag]: '/blog/tag/:tag/:page?',
    [Config.routes.blog.glossaryItem]: '/blog/glossary/:glossaryItem',
};

const cs = {
    default: IS_CS_LANG_ENV,
    locale: 'cs',
    label: 'CZ',
    routes: csRoutes,
};

const en = {
    default: IS_EN_LANG_ENV,
    locale: 'en',
    label: 'EN',
    routes: enRoutes,
};

const de = {
    default: IS_DE_LANG_ENV,
    locale: 'de',
    label: 'DE',
    routes: deRoutes,
};

const getRoutes = () => {
    if (IS_DE_LANG_ENV) {
        return [de];
    }
    if (IS_EN_LANG_ENV) {
        return [en];
    }

    return [cs];
};

exports.languages = getRoutes();
